import type { IApiClient } from "@/lib/__shared__/apiClient";
import type { AttributionTouch } from "@coffitivity/shared";

const API_BASE = import.meta.env.VITE_USER_SERVER_URL;

export type { AttributionTouch } from "@coffitivity/shared";

export interface IAttributionService {
	recordTouch(_touch: AttributionTouch): Promise<void>;
}

export class AttributionService implements IAttributionService {
	private apiClient: IApiClient;

	constructor(apiClient: IApiClient) {
		this.apiClient = apiClient;
	}

	/**
	 * Append an Attribution Touch to the ledger.
	 *
	 * Goes through the authenticated client on purpose: an already-signed-in
	 * Visitor returning through a campaign link is the re-acquisition case, and
	 * the API attributes those touches immediately rather than waiting for a
	 * binding that will never come.
	 */
	async recordTouch(_touch: AttributionTouch): Promise<void> {
		const response = await this.apiClient.fetch(
			`${API_BASE}/attribution/touch`,
			{
				method: "POST",
				body: JSON.stringify(_touch),
			},
		);

		if (!response.ok) {
			const json = await response.json().catch(() => ({}));
			throw new Error(json.message ?? "Failed to record attribution touch.");
		}
	}
}
